import unAuthAxios from '../../../Utils/unAuthAxios';
import axios from '../../../Utils/axios';
import $ from 'jquery';

const globals = require('../../../config/' +
  process.env.REACT_APP_STAGE +
  '/Portal/globals');

// GET param 변환
export function getURL(API, param) {
  let url = API;
  if (param !== undefined && param !== '') {
    for (let val in param) {
      if (
        !(
          param[val] === undefined ||
          param[val] === null ||
          String(param[val]) === ''
        )
      ) {
        if (url.indexOf('?') > -1) url += '&';
        else url += '?';
        url += val + '=' + param[val];
      }
    }
  }
  return url;
}

/**
 * TIN 유효성 체크
 */
const isTin = (param) => {
  const url = getURL(`${globals.exApiUrl}/company/exist/tin`, param);

  return unAuthAxios.get(url).then((response) => {
    return response;
  });
};

const getCompany = (param) => {
  const url = getURL(`${globals.exApiUrl}/company/${param.companyNo}`);

  return unAuthAxios.get(url).then((response) => {
    return response;
  });
};

const getCompanyByTinAndBranchCode = (param) => {
  const url = getURL(
    `${globals.exApiUrl}/company/invite?companyTin=${param.companyTin}&companyBranchCode=${param.companyBranchCode}&session=${param.session}&email=${param.email}`
  );

  return unAuthAxios.get(url).then((response) => {
    return response;
  });
};

const updateCompany = (param) => {
  const url = getURL(`${globals.exApiUrl}/company`);

  return axios.put(url, param).then((response) => {
    return response;
  });
};

const deleteEmployee = (param) => {
  const url = getURL(`${globals.exApiUrl}/company/member/resign`, param);

  return axios.delete(url, param).then((response) => {
    return response;
  });
};

const inviteEmployee = (param) => {
  const url = getURL(`${globals.exApiUrl}/company/member/invite`, {
    companyNo: param.companyNo,
    userNo: param.userNo,
  });

  const body = [
    {
      firstName: param.firstName,
      middleName: param.middleName,
      lastName: param.lastName,
      email: param.email,
    },
  ];

  return axios.post(url, body).then((response) => {
    return response;
  });
};

const getTaxpayerDetail = (param) => {
  const url = getURL(`${globals.exApiUrl}/company/taxpayer`, param);

  return axios.get(url, param).then((response) => {
    return response;
  });
};

export default {
  isTin,
  getCompany,
  getCompanyByTinAndBranchCode,

  updateCompany,
  deleteEmployee,
  inviteEmployee,

  getTaxpayerDetail,
};
